import React, { Fragment } from 'react'
import * as jsonLogic from 'json-logic-js'

import {
  SpacerVertical,
  Typography,
  SpacerHorizontal,
  IconCalendar,
  IconScissors,
  IconHourglass,
  IconTransfer,
  IconCreditCard,
  Frame
} from '@klarna/bubble-ui'

import LearnMoreLegal from '../../Legal'
import { CheckoutProps } from './Checkout'

const Illustrations = {
  IconCalendar: <IconCalendar size={20} />,
  IconScissors: <IconScissors size={20} />,
  IconHourglass: <IconHourglass size={20} />,
  IconTransfer: <IconTransfer size={20} />,
  IconCreditCard: <IconCreditCard size={20} />,
  IconCalendarLarge: <IconCalendar size={48} />,
  IconScissorsLarge: <IconScissors size={48} />,
  IconHourglassLarge: <IconHourglass size={48} />,
  IconTransferLarge: <IconTransfer size={48} />
}

export const NonAmountBasedModal = (
  {
    copy, darkThemeToken
  }: CheckoutProps
) => {
  if (!copy) return null

  const renderPaymentMethodDetails = (heading: string, paragraph?: string) => (
    <Fragment>
      <Typography textToken='text-style/text/labels/body/bold'>
        {heading}
      </Typography>
      <SpacerVertical spaceToken='space.0' />
      <Typography textToken='text-style/text/labels/tiny/regular' colorToken='colors/text/subtle'>
        {paragraph}
      </Typography>
    </Fragment>
  )

  const renderGenericLegal = (genericLegal: any) => (
    <Fragment>
      <LearnMoreLegal copy={genericLegal.legal} />
      {genericLegal.disclaimer && Object.keys(genericLegal.disclaimer).length
        ? <Fragment>
          <SpacerVertical spaceToken='space.100' />
          <LearnMoreLegal copy={genericLegal.disclaimer} />
        </Fragment>
        : null
      }
    </Fragment>
  )

  let filteredArrLength: number
  const getGroupedPaymentMethodsArray = () => {
    const paymentMethodsToDisplay = copy.payment_methods
      .filter((paymentMethod: any) => !paymentMethod.displayCondition || jsonLogic.apply(paymentMethod.displayCondition))
      .map((paymentMethod: any) => [paymentMethod])
    filteredArrLength = paymentMethodsToDisplay.length
    let groupedMethodsArray

    if (!paymentMethodsToDisplay || paymentMethodsToDisplay.length === 0) return []
    const [first, second, third, ...rest] = paymentMethodsToDisplay
    if (paymentMethodsToDisplay.length >= 3) {
      groupedMethodsArray = [first, [...second, ...third], ...rest]
    } else if (paymentMethodsToDisplay.length === 2) {
      groupedMethodsArray = [first, second]
    } else {
      groupedMethodsArray = [first]
    }
    return groupedMethodsArray
  }

  const getDisplayedPaymentMethodsCopies = () => {
    const legalDisclosuresToDisplay = copy.payment_methods
      .filter((paymentMethod: any) => !paymentMethod.displayCondition || jsonLogic.apply(paymentMethod.displayCondition))
    return legalDisclosuresToDisplay
  }

  return (
    <Fragment>
      <Typography textToken='text-style/headings/titles/bold/tertiary' textAlignToken='text-alignment/start'>
        {copy.title}
      </Typography>
      {getGroupedPaymentMethodsArray().map((groupedMethods: any, groupedMethodsIndex: number) => (
        <div className='nonAmountBasedMainContainer'>
          {groupedMethods.map((paymentMethod: any, index: number) => (
            <div className={groupedMethods.length === 1 ? 'singePaymentMethodContainer' : 'multiplePaymentMethodContainer'}>
              <Fragment key={`${paymentMethod}-${index}`}>
                <SpacerVertical spaceToken='space.200' />
                <Frame backgroundColorToken={darkThemeToken}>
                  {groupedMethodsIndex === 0
                    ? (<div className='largeIllustrationContainer'>
                      {Illustrations[`${paymentMethod.illustration}Large`]}
                      <SpacerHorizontal spaceToken='space.0' />
                      <div style={{ width: '100%' }}>
                        {renderPaymentMethodDetails(paymentMethod.heading, paymentMethod?.paragraph)}
                      </div>
                    </div>)
                    : (<div className={(filteredArrLength >= 3 && groupedMethodsIndex === 1) ? '' : 'flexRowContainer'}>
                      {Illustrations[paymentMethod.illustration]}
                      <SpacerHorizontal spaceToken='space.50' />
                      <div style={{ width: '100%' }}>
                        {renderPaymentMethodDetails(paymentMethod.heading, paymentMethod?.paragraph)}
                      </div>
                    </div>)
                  }
                </Frame>
              </Fragment>
            </div>
          ))}
        </div>
      ))}
      <SpacerHorizontal spaceToken='space.400' />
      {Object.keys(copy.genericLegal).length
        ? renderGenericLegal(copy.genericLegal)
        : null
      }
      {getDisplayedPaymentMethodsCopies().map((paymentMethod: any) => (paymentMethod.legal && Object.keys(paymentMethod.legal).length
        ? <LearnMoreLegal copy={paymentMethod.legal} />
        : null))
      }
    </Fragment>
  )
}